import React, { useContext } from 'react';
import { motion } from 'framer-motion';
// import { secondsInPast, parentHeatsInPast } from '../../Utils/time';

import './ranking-table.scss';
import { AppContext } from '../../App';
import { Athlete } from './athlete';
import { getTrans } from '../../Utils/translate';

const rankSort = (a, b) => {
  if (a.rank > b.rank) return 1;
  if (a.rank < b.rank) return -1;
  return 0;
};

const RankingTable2 = ({ heat, data, config }) => {
  const context = useContext(AppContext);
  const animationConfig = context.config.animation;
  const { statusText, top32, top16, final, quarterFinal, semifinal, qualifiers } =
    context.lang;

  const containerAnimation = {
    hidden: {
      opacity: 1,
      scale: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };

  if (!heat || Object.keys(heat).length === 0) {
    return <>No Results selected</>;
  }

  const getStatusWording = (status) => {
    const camel =
      status.replace(/_([a-z])/g, function (g) {
        return g[1].toUpperCase();
      }) + 'Text';

    if (context.lang[camel]) {
      return getTrans(context.lang[camel]);
    }
    return camel;
  };

  // const showResultsPast = secondsInPast(
  //   new Date(heat.resultIsOfficialTimestamp),
  //   config.delayDataSeconds || 60
  // );

  let showAthlets = heat.athletes;

  // if (data) {
  //   showAthlets = parentHeatsInPast(heat, data, config.delayDataSeconds || 60);
  // }

  const status = getStatusWording(heat.heat_status.active_status);

  const getHeatTrans = (name) => {
    switch (name) {
      case 'Top32':
        return getTrans(top32);

      case 'Top16':
        return getTrans(top16);

      case 'Final':
        return getTrans(final);

      case 'Quarterfinals':
        return getTrans(quarterFinal);

      case 'Semifinals':
        return getTrans(semifinal);

      case 'Qualifiers':
        return getTrans(qualifiers);

      default:
        return name;
    }
  };

  const getHeatName = (heatName) => {
    let heat;
    if (heatName && typeof heatName === 'string') {
      heat = heatName.split('>');

      if (heat.length === 1) {
        return heat[0];
      } else if (heat.length > 1) {
        return getHeatTrans(heat[0].trim()) + ' >' + heat[1];
      }
    }
    return heatName;
  };

  return (
    <motion.div
      className="appRow ranking2 full-width-generic"
      key={`heat-${heat.id}`}
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
    >
      <div className="ranking2__header">
        <h6 className="h6">{heat.name === null || getHeatName(heat.name)}</h6>
        <span className="ranking-status">
          {getTrans(statusText)}: {status}
        </span>
      </div>
      <table>
        <tbody>
          {heat &&
            showAthlets &&
            heat.results &&
            heat.results.sort(rankSort).map((result, index) => {
              const athlete =
                heat.athletes.find(({ id }) => '' + result.athlete === '' + id) ||
                heat.athletes[index];
              return (
                <Athlete
                  athlete={athlete}
                  result={result}
                  heat={heat}
                  // showResultsPast={showResultsPast}
                  key={`athlete-${heat.id}${athlete.id || 'i' + index}`}
                  index={index}
                  config={config}
                  showAthleteImage={config.showAthleteImage}
                  crosslinkDetails={config.crosslinkDetails}
                />
              );
            })}
        </tbody>
      </table>
    </motion.div>
  );
};

export { RankingTable2 };
